
import {
  formatPoints,
  getCoverUrl,
  getProductDescription,
  getProductPoints,
  getProductTitle,
  isProductOutOfStock,
  isPointsApiSuccess,
  normalizeMallGoodsList,
} from "@/utils/mallGoods";
import { ensureMallSite } from "@/utils/mallSite";

export default {
  name: "XcoinsMoreProducts",
  props: {
    excludeId: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      moreList: [],
      canScrollLeft: false,
      canScrollRight: false,
    };
  },
  watch: {
    excludeId() {
      this.fetchMore();
    },
  },
  mounted() {
    this.fetchMore();
    window.addEventListener("resize", this.updateMoreArrows);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateMoreArrows);
  },
  methods: {
    formatPoints,
    getCoverUrl,
    getProductTitle,
    getProductDescription,
    getProductPoints,
    isProductOutOfStock,
    goGoods(id) {
      if (!id) {
        return;
      }
      this.$router.push(`/xcoins/goods/${id}`);
    },
    async fetchMore() {
      if (!this.excludeId) {
        this.moreList = [];
        return;
      }
      try {
        await ensureMallSite(this.$cookies);
        const res = await this.$global.pointsMallGoodsMore({
          goodsId: this.excludeId,
        }).catch(() => null);
        if (!isPointsApiSuccess(res)) {
          this.moreList = [];
          return;
        }
        this.moreList = normalizeMallGoodsList(res.data || []);
        this.$nextTick(this.updateMoreArrows);
      } catch (e) {
        this.moreList = [];
      }
    },
    scrollMore(direction) {
      const scroller = this.$refs.moreScroller;
      if (!scroller) {
        return;
      }
      scroller.scrollBy({
        left: direction * Math.max(scroller.clientWidth * 0.8, 280),
        behavior: "smooth",
      });
    },
    updateMoreArrows() {
      const scroller = this.$refs.moreScroller;
      if (!scroller) {
        this.canScrollLeft = false;
        this.canScrollRight = false;
        return;
      }
      this.canScrollLeft = scroller.scrollLeft > 8;
      this.canScrollRight =
        scroller.scrollLeft + scroller.clientWidth < scroller.scrollWidth - 8;
    },
  },
};
